import 'text-encoding'; 
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import { Provider } from 'react-redux';
import {store,persistor} from './store/store'
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';

import { Elements } from '@stripe/react-stripe-js';
import { stripePromise } from './utils/stripe/stripe.utils';
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor} >
        <Elements stripe={stripePromise}>
          <App />
          </Elements>
       </PersistGate>
    </Provider>
  </React.StrictMode>
);

serviceWorkerRegistration.register();
